import { getApiErrorMessage } from "../../../../../utils/commonFunction";
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */

import * as Yup from "yup";

import React, { useCallback, useEffect, useState } from "react";

import ActiveDialogModal from "../../../../../../_metronic/_partials/widgets/alert/ActiveDialogModal";
import CountryForm from "../country-form/countryForm";
import { CountrySchema } from "../country-form/validateSchema";
import SnackBarTool from "../../../../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import { canvaCancel } from "../../../../../utils/canvaCloseFunction";
import countryApi from "../../../../../utils/countryApi.json";
import { editCountry } from "../../../_redux/country/countryCrud";
import { fetchCountryDetail } from "../../../_redux/country/countryAction";
import languageByCountryApi from "../../../../../utils/languageByCountryApi.json";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { useIntl } from "react-intl";

export function EditCountryCanva({ detailData }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  //country list json
  countryApi.sort((a, b) => (a.name.common > b.name.common ? 1 : -1));

  const [dialog, setDialog] = useState(false);
  const [formData, setFormData] = useState();
  const [snack, setSnack] = useState({ call: false, type: "", message: "" });
  const [active, setActive] = useState(false);
  const [check, setCheck] = useState(false);
  const [languageData, setLanguageData] = useState([]);

  const initialValues = {
    name: detailData && detailData.name ? detailData.name : "",
    short_name:
      detailData && detailData.short_name ? detailData.short_name : "",
    language: detailData && detailData.language ? detailData.language : "",
    currency: detailData && detailData.currency ? detailData.currency : "",
    timezone: detailData && detailData.timezone ? detailData.timezone : "",
    status: detailData && detailData.status ? detailData.status : "0",
  };

  // Custom hook for handling form submission
  const handleSubmit = (values) => {
    // Resets the snackbar state
    setSnack({ call: false, type: "", message: "" });

    // Calls the editCountry function and displays a success or error message in the snackbar
    editCountry(values, detailData.id)
      .then((res) => {
        setSnack({ call: true, type: "success", message: res.data.message });
        dispatch(fetchCountryDetail(detailData.id));
        canvaCancel("kt_edit_country_panel_close");
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message: getApiErrorMessage(error),
        });
      });
  };

  const handleReset = () => {};

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: CountrySchema(intl, Yup),
    onSubmit: handleSubmit,
    onReset: handleReset,
  });

  // Custom hook that handles the selection of a country
  const handleSelectCountry = useCallback(
    async (e) => {
      // Finds the country data associated with the selected country name
      let data = countryApi.find((element) => element.name.common === e);

      // Sets the form data and formik field values for the selected country
      setFormData(data);
      formik.setFieldValue("name", e);
      formik.setFieldValue("short_name", data.cca3);
      await formik.setFieldValue("currency", data.currencies[0].name);

      // If the "check" variable is truthy, sets the timezone and language field values
      if (check) {
        if (data.timezones.length === 1) {
          formik.setFieldValue("timezone", data.timezones[0]);
        } else {
          await formik.setFieldValue("timezone", "");
        }
        await formik.setFieldValue("language", "");
      }
    },
    [check, formik]
  );

  // Custom hook that updates the form data and language data when the name field changes
  useEffect(() => {
    // If the name field has a value and the "check" variable is falsy, updates the form data and sets "check" to true
    if (formik.values.name && !check) {
      handleSelectCountry(formik.values.name);
      setCheck(true);
    }
  }, [check, formik.values.name, handleSelectCountry]);

  // Custom hook that updates the language data when the name field changes
  useEffect(() => {
    // Finds the language data associated with the selected country name
    if (formik?.values?.name) {
      const languageList = languageByCountryApi.find(
        (element) => element.country === formik?.values?.name
      );
      // Sets the language data
      setLanguageData(languageList && languageList.languages);
    }
  }, [formik.values.name]);

  useEffect(() => {
    // Event listener callback function that resets the form if the user clicks outside the form
    const checkIfClickedOutside = (e) => {
      if (e.target.className === "offcanvas-overlay") {
        formik.resetForm();
      }
    };

    document.addEventListener("click", checkIfClickedOutside, true);
    return () => {
      document.removeEventListener("click", checkIfClickedOutside, true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      id="kt_edit_country_panel"
      className={`offcanvas offcanvas-right pt-5 pb-10 `}
    >
      {/*begin::Header*/}
      <div className="offcanvas-header offcanvas-header-navs d-flex align-items-center justify-content-between mb-5">
        <div
          className="offcanvas-close mt-n1 pr-5"
          style={{ position: "absolute", top: "15px", right: "10px" }}
        >
          <span
            className="btn btn-xs btn-icon btn-light btn-hover-primary"
            id="kt_edit_country_panel_close"
            onClick={() => formik.handleReset()}
          >
            <i className="ki ki-close icon-xs text-muted"></i>
          </span>
        </div>
      </div>

      {/*end::Header*/}

      {/*begin::Content*/}
      <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
        <div className="offcanvas-content px-10">
          <div>
            <h5>{intl.formatMessage({ id: "Edit.Country" })}</h5>
          </div>
          <div className="tab-content">
            <div
              id="kt_quick_panel_logs_kt_edit_country_panel"
              role="tabpanel"
              className={`tab-pane fade pt-3 pr-5 mr-n5 scroll  active show `}
            >
              <CountryForm
                intl={intl}
                formik={formik}
                countryApi={countryApi}
                handleSelectCountry={handleSelectCountry}
                languageData={languageData}
                formData={formData}
                setDialog={setDialog}
              />
            </div>
          </div>
        </div>
        <ActiveDialogModal
          active={active}
          setActive={setActive}
          dialog={dialog}
          setDialog={setDialog}
          formik={formik}
        />
        <div className="offcanvas-footer">
          <div className="offcanvas-content text-right ">
            <button
              type="reset"
              // id="kt_edit_country_panel_cancel"
              className="btn btn-dark font-weight-bolder font-size-sm mr-3 "
              onClick={() => canvaCancel("kt_edit_country_panel_close")}
            >
              {intl.formatMessage({ id: "CANCEL" })}
            </button>
            <button
              type="submit"
              className="btn btn-primary font-weight-bolder font-size-sm "
            >
              {intl.formatMessage({ id: "SAVE" })}
            </button>
          </div>
        </div>
      </form>
      {snack.call ? <SnackBarTool {...snack} /> : ""}
    </div>
  );
}
